import { render, staticRenderFns } from "./chAp.vue?vue&type=template&id=d6ab05b4"
import script from "./chAp.vue?vue&type=script&lang=js"
export * from "./chAp.vue?vue&type=script&lang=js"
import style0 from "./chAp.vue?vue&type=style&index=0&id=d6ab05b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports